<template>
  <div class="page-wrapper">
    <search-group
      title="VR信息查询" :inline="true"
      :span="24" :btnOffset="21" :btnSpan="6"
      @search="findData" @clear="clearValue"
    >
      <Row :gutter="18" class="mb16">
        <Col span="3">
          <Select placeholder="业务线"  v-model="searchData.serviceType" @on-change="changeServiceType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in serviceTypeList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Select placeholder="项目名称" v-model="searchData.projectFid" @on-change="changeProject">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="楼栋" v-model="searchData.buildingFid" @on-change="changeBuild">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in buildingList" :value="item.value" :key="'keyC'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select placeholder="房型名称/公区名称" v-model="searchData.moduleFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in houseTypeAndAreaList" :value="item.value" :key="'keyE'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="状态" v-model="searchData.state">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in stateList" :value="item.value" :key="'keyF'+index">{{item.text}}</Option>
          </Select>
        </Col>

      </Row>

    </search-group>
    <div class="page-wrapper">
      <div class="mb16">
        <Button v-p="{api:'vr/save'}" type="primary" @click.stop="toAdd">添加VR房源</Button>
        <Button v-p="{api:'vr/getVrUrl'}" type="primary" @click.stop="getVrUrl('')">批量获取VR链接</Button>
      </div>
      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
    </div>
    <add
      :n="addN"
      :serviceTypeList="serviceTypeList"
      @adddone="vrlist(searched)"
    ></add>
    <update
      :n="updateN"
      :serviceTypeList="serviceTypeList"
      :formDataOri="updateItem"
      @updateClose="clearUpdateItem"
      @updatedone="vrlist(searched)"
    ></update>

  </div>
</template>

<script>
  import SearchGroup from 'components/SearchGroup/index';
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import Update from './components/Update'
  import {projectAndBuild,getHouseTypeAndArea,getVRState,vrlist,
    housetypeforProject,vrdelete,getVrUrl} from "../../api/vrmanage";
  import {deepClone} from "../../utils/format";
  import {formatDateTime} from "../../utils/format";

  export default {
    name: "vrmanage",
    components:{
      SearchGroup,
      TableList,
      Add,
      Update
    },
    created(){
      this.getVRState()
      this.vrlist(this.searchData)
    },
    data(){
      return {
        updateN:0,
        updateItem:null,
        addN:0,
        stateList:[],
        houseTypeAndAreaList:[],
        projectList:[],
        buildingList:[],
        serviceTypeList:[{text:'自如寓',value:1},{text:'自如驿',value:2}],
        searchData:{
          page:1,
          limit:10,
          serviceType:'',
          projectFid:'',
          buildingFid:'',
          moduleFid:'',
          state:''
        },
        searched:null,
        columns:[
          {
            title: "业务线",
            key: "serviceType",
            align: "center",
            render:(h,params)=>{
              let map={
                '1':'自如寓',
                '2':'自如驿'
              }
              return h('span',{},map[params.row['serviceType']+''] || '-')
            }
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
            render:(h,params)=>{
              return h('span',{},params.row['projectName']||'-')
            }
          },
          {
            title: "楼栋",
            key: "buildingName",
            align: "center",

            render:(h,params)=>{
              return h('span',{},params.row['buildingName']||'-')
            }
          },
          {
            title: "拍摄类型",
            key: "areaType",
            align: "center",
            render:(h,params)=>{
              var map={
                '1':'房源',
                '2':'公区'
              }
              return h('span',{},map[params.row['areaType']+'']||'-')
            }
          },
          {
            title: "房源编号/区域名称",
            key: "roomName",
            align: "center",
            render:(h,params)=>{
              return h('span',{},params.row['roomName']||'-')
            }
          },
          {
            title: "房型/公区名称",
            key: "moduleName",
            align: "center",

            render:(h,params)=>{
              return h('span',{},params.row['moduleName']||'-')
            }
          },
          {
            title: "VR链接",
            key: "vrUrl",
            align: "center",
            minWidth:'200',

            render:(h,params)=>{
              return h('span',{},params.row['vrUrl']||'-')
            },
            // render: (h, params) => {
            //   if (params.row['vrUrl'] && params.row['vrUrl'].length >= 20) {
            //     return h('span', {
            //       attrs: {
            //         title: params.row['vrUrl']
            //       },
            //       style: {
            //         cursor: 'grab'
            //       }
            //     }, params.row['vrUrl'].slice(0, 20) + '...')
            //   }
            //   else {
            //     return h('span', {}, params.row['vrUrl'] || '-')
            //
            //   }
            // }

          },
          {
            title: "状态",
            key: "state",
            align: "center",
            render:(h,params)=>{
              let map={
                '1':'待下单' ,'2':'已下单', '3':'已拍摄 ',
              }
              return h('span',{},map[params.row['state']+''] || '-')
            }
          },
          {
            title: "更新时间",
            key: "lastModifyTime",
            align: "center",
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['lastModifyTime'])||'-')
            }
          },
          {
            title: "操作",
            key: "",
            align: "center",
            render:(h,params)=>{
              let _this=this
              let update=h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'vr/update'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                  _this.updateItem=params.row
                    _this.updateN++
                  }

                }
              },'修改')
              let deleteItem=h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'vr/delete'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    _this.deleteItem(params.row)
                  }
                }

              },'删除')
              let getUrl=h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'vr/getVrUrl'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    _this.getVrUrl(params.row['fid'])
                  }
                }
              },'获取链接')
              let actions=[]
              if(params.row['state']===1){
                actions.push(update,deleteItem)
              }
              if(params.row['state']!==1){
                actions.push(getUrl)
              }

              return h('div',{},actions)
              // return h('span',{},formatDateTime(params.row['lastModifyTime'])||'-')
            }
          },
        ],
        data:[],
        loading:false,
        total:0,
        current:1,
      }
    },
    computed:{
      projectListMap(){
        let ret={}
        this.projectList.forEach(ele=>{
          ret[ele.value+'']=ele
        })
        return ret
      }
    },
    methods:{
      getVrUrl(value){
        getVrUrl({vrFid:value}).then(res=>{
          this.$Message.success('获取VR链接成功')
          this.vrlist(this.searched)
        }).catch(error=>{})

      },
      deleteItem(item){
        this.$Modal.confirm({
          title: 'VR删除',
          content: '<p>删除信息后无法恢复，确认删除本条信息么？</p>',
          onOk: () => {
            let params={
              VRFid:item.fid
            }
            vrdelete(params).then(res=>{
              this.$Message.success('删除成功')
              this.searched.page=1
              this.current=1
              this.vrlist(this.searched)
            }).catch(error=>{})
          }
        })

      },
      clearUpdateItem(){
        this.updateItem=null
      },
      toAdd(){
        this.addN++

      },
      vrlist(data){
        this.total = 0
        this.data = []
        vrlist(data).then(res => {
          if (!res.data) {
            return
          }
          this.total = res.data.total
          this.data = res.data.rows
          this.searched = deepClone(data)
        }).catch(error => {
        })
      },
      changeBuild(value){
        this.searchData.moduleFid=''
        this.houseTypeAndAreaList=[]
        if(value || value===0){
          this.getHouseTypeAndArea()
        }
      },
      changeProject(value){
        this.searchData.buildingFid=''
        this.buildingList=[]
        this.searchData.moduleFid=''
        this.houseTypeAndAreaList=[]

        if(value || value===0){
          this.buildingList=this.projectListMap[''+value].children
        }
      },
      getVRState(){
        getVRState().then(res=>{
          res.data && ( this.stateList=res.data.VRState )
        })
      },
      getHouseTypeAndArea(){
        let params={
          projectFid:this.searchData.projectFid,
          buildingFid:this.searchData.buildingFid,
          serviceType:this.searchData.serviceType
        }
        getHouseTypeAndArea(params).then(res=>{
          res.data && ( this.houseTypeAndAreaList=res.data)
        }).catch(error=>{})

      },
      changeServiceType(value){
        // this.searchData={
        //   page:1,
        //   limit:10,
        //   serviceType:'',
        //   projectFid:'',
        //   buildingFid:'',
        //   moduleFid:'',
        //   state:''
        // }
        this.searchData.projectFid=''
        this.projectList=[]
        this.searchData.buildingFid=''
        this.buildingList=[]
        this.searchData.moduleFid=''
        this.houseTypeAndAreaList=[]

        if(value || value===0){
          this.projectAndBuild(value)
        }
      },

      projectAndBuild(value){
        let params={
          serviceType:value
        }
        projectAndBuild(params).then(res=>{
          this.projectList=res.data
        }).catch(error=>{})


      },
      changePage(n){
        this.searched.page = n
        this.current = n
        this.vrlist(this.searched)
      },
      findData(){
        this.current = 1
        this.searchData.page = 1
        this.vrlist(this.searchData)
      },
      clearValue(){
        this.searchData={
          page:1,
          limit:10,
          serviceType:'',
          projectFid:'',
          buildingFid:'',
          moduleFid:'',
          state:''
        }
        this.projectList=[]
        this.buildingList=[]
        this.houseTypeAndAreaList=[]


      }
    }
  }
</script>

<style scoped>
  .page-wrapper{
    padding-top: 0;
  }

</style>
